import { render, staticRenderFns } from "./wxhuizong.vue?vue&type=template&id=d30e2cf8"
import script from "./wxhuizong.vue?vue&type=script&lang=js"
export * from "./wxhuizong.vue?vue&type=script&lang=js"
import style0 from "./wxhuizong.vue?vue&type=style&index=0&id=d30e2cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports